import React from "react";
import { useTheme } from "../../contexts/ThemeContext";

const BasicModal = ({
  icon,
  type,
  open,
  title,
  text,
  subtitle,
  paragraph,
  paymentParagraph,
  onCancel,
  onConfirm,
  confirmText,
  cancelText,
}) => {
  console.log("START TO OPEN MODAL");
  const { theme } = useTheme();
  if (!open) return null;
  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100vw",
        height: "100vh",
        background: "rgba(0,0,0,0.35)",
        zIndex: 9999,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <div
        style={{
          backgroundColor: theme.surface,
          borderRadius: "12px",
          padding: "30px",
          maxWidth: "500px",
          width: "90%",
          border: `1px solid ${theme.border}`,
        }}
      >
        <div
          style={{
            backgroundColor: theme.surface,
            display: "flex", // Add this line
            flexDirection: "row",
            alignItems: "center",
            gap: "12px",
          }}
        >
          {icon && <div style={{ fontSize: 24 }}>{icon}</div>}
          <div
            style={{
              fontSize: 24,
              fontWeight: 700,
              marginBottom:
                type === "subscriptionLimit" ||
                (type === "subscriptionExpired" && "10px"),
            }}
          >
            {title}
          </div>
        </div>
        {subtitle && (
          <div
            style={{
              fontSize: 16,
              color: theme.textSecondary,
              marginBottom: 20,
              whiteSpace: "pre-line", // Add this line
            }}
          >
            {subtitle}
          </div>
        )}
        {text && (
          <div
            style={{
              fontSize: 16,
              color: theme.textSecondary,
              marginBottom: 20,
              whiteSpace: "pre-line", // Add this line
              lineHeight: "25px",
              marginTop:
                type === "subscriptionLimit" ||
                (type === "subscriptionExpired" && "15px"),
            }}
          >
            {text}
          </div>
        )}
        {paragraph && (
          <div
            style={{
              fontSize: 16,
              color: theme.textSecondary,
              marginBottom: 20,
              whiteSpace: "pre-line", // Add this line
            }}
          >
            {paragraph}
          </div>
        )}
        {paymentParagraph && (
          <div
            style={{
              fontSize: 16,
              color: theme.textSecondary,
              marginBottom: 20,
              whiteSpace: "pre-line", // Add this line
            }}
          >
            {paymentParagraph}
          </div>
        )}
        <div
          style={{
            height: "1px",
            margin: "12px 0", // Adjust spacing as needed
            backgroundColor: "cadetblue",
          }}
        />
        <div style={{ display: "flex", gap: 12, justifyContent: "flex-end" }}>
          <div style={{ display: "flex", gap: 12, justifyContent: "flex-end" }}>
            {onCancel && (
              <button
                style={{
                  backgroundColor: "unset",
                  border: "none",
                  color: "indianred",
                  marginRight: "12px",
                  padding: "8px 16px",
                  borderRadius: "8px",
                  cursor: "pointer",
                  transition: "all 0.2s ease",
                }}
                onClick={onCancel}
              >
                <p style={{ fontSize: 16, fontWeight: 600 }}>
                  {cancelText || "Cancel"}
                </p>
              </button>
            )}

            <button
              className="modal-primary-button modal-button-glow"
              style={{
                backgroundColor: "cadetblue",
                border: "none",
                color: "white",
                marginRight: "12px",
                padding: "8px 16px",
                borderRadius: "8px",
                cursor: "pointer",
                transition: "all 0.2s ease",
                fontWeight: "600",
                fontSize: "16px",
                boxShadow: "0 2px 8px rgba(95, 158, 160, 0.3)",
              }}
              onClick={onConfirm}
            >
              {confirmText || "OK"}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BasicModal;
